<template>
    <v-dialog v-model="dialogForm" scrollable persistent content-class="dialog-pdv br-15">
        <v-card>
            <v-toolbar elevation="0" dark class="primary-degrade white--text fix-flex">
                <v-toolbar-title>
                    {{ formTitulo }} - Etapa ({{ passo }} de 5)
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn fab width="24px" height="24px" elevation="0" color="#fff" @click="dialogForm = false">
                    <v-icon size="18px" color="primary">mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-stepper v-model="passo" non-linear class="elevation-0 card-body">
                <v-stepper-header class="px-2">
                    <v-stepper-step editable error-icon="mdi-alert-circle" :rules="regra.etapa1" step="1" @click="irParaEtapa(1)">Cadastro de Acordo</v-stepper-step>
                    <v-divider class="mx-2"></v-divider>
                    <v-stepper-step editable error-icon="mdi-alert-circle" :rules="regra.etapa2" step="2" @click="irParaEtapa(2)">Seleção de Filiais</v-stepper-step>
                    <v-divider class="mx-2"></v-divider>
                    <v-stepper-step editable error-icon="mdi-alert-circle" :rules="regra.etapa3" step="3" @click="irParaEtapa(3)">Descontos</v-stepper-step>
                    <v-divider class="mx-2"></v-divider>
                    <v-stepper-step editable error-icon="mdi-alert-circle" :rules="regra.etapa4" step="4" @click="irParaEtapa(4)">Seleção de Produtos</v-stepper-step>
                    <v-divider class="mx-2"></v-divider>
                    <v-stepper-step editable error-icon="mdi-alert-circle" :rules="regra.etapa5" step="5" @click="irParaEtapa(5)">Resumo</v-stepper-step>
                </v-stepper-header>
                <div class="etapas-conteudo">
                    <v-stepper-items class="min-h-100">
                        <v-stepper-content class="min-h-100" step="1">
                            <Cadastro ref="cadastro" :usuarioTipo="usuarioTipo" v-model="acordo" @limpaProdutos="$refs.produto.limpaProdutos()" />
                        </v-stepper-content>
                        <v-stepper-content class="min-h-100" step="2">
                            <Filial ref="filial" v-model="acordo" />
                        </v-stepper-content>
                        <v-stepper-content class="min-h-100" step="3">
                            <Desconto ref="desconto" v-model="acordo" />
                        </v-stepper-content>
                        <v-stepper-content class="min-h-100" step="4">
                            <Produto ref="produto" v-model="acordo" />
                        </v-stepper-content>
                        <v-stepper-content class="min-h-100" step="5">
                            <Resumo ref="resumo" v-model="acordo" :key="resumoKey" />
                        </v-stepper-content>
                    </v-stepper-items>
                </div>
                <div class="d-flex card-footer pa-4">
                    <v-btn color="yellow" width="130px" :disabled="disabledVoltar" @click="voltar" class="new-button" dark>
                        <v-icon left>mdi-chevron-left-circle</v-icon>
                        Voltar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" width="130px" @click="proximo" class="new-button" :disabled="carregando" v-if="!acordo.fnLeitura || passo < 5">
                        {{ botao }}
                        <v-icon right>{{ botaoIco }}</v-icon>
                    </v-btn>
                </div>
            </v-stepper>
        </v-card>
    </v-dialog>
</template>

<script>
import Cadastro from './Cadastro.vue'
import Produto from './Produto.vue'
import Resumo from './Resumo.vue'
import Desconto from './Desconto.vue'
import Filial from './Filial.vue'

export default {
    name: 'FormularioCircuito',
    provide() {
        return {
            listaCampos: this.listaCampos,
            usuarioTipo: this.usuarioTipo,
        }
    },
    components: {
        Cadastro,
        Filial,
        Desconto,
        Produto,
        Resumo,
    },
    data() {
        return {
            acordo: {
                mesInicial: null,
                mesFinal: null,
                id_espaco: 3658,
                id_fornecedor: null,
                fornecedor: null,
                fornecedorDesconto: null,
                bandeira: [],
                obs_departamento: null,
                obs_contrato: null,
                comentario: null,
                fnEditar: false,
                fnLeitura: false,
                preAcordo: false,
                id_acordo_title: 0,
                valores: [],
            },
            usuarioTipo: 'rd',
            dialogForm: false,
            passo: 1,
            botao: 'Próximo',
            botaoIco: 'mdi-chevron-right',
            disabledVoltar: true,
            carregando: false,
            alerta: false,
            alertaTexto: '',
            alertaColor: 'error',
            alertaTimeout: 3000,
            paginationErro: {},
            dialogoErro: false,
            listaHeaderErro: [
                { text: 'Descrição do Erro', value: 'msg', align: 'left' },
            ],
            listaErro: [],
            listaErroLabels: { msg: 'Descrição do Erro' },
            status: {},
            regra: {
                etapa1: [() => { if (this.passo > 1) { return this.$refs.cadastro && this.$refs.cadastro.validate ? this.$refs.cadastro.validate() : true } return true }],
                etapa2: [() => { if (this.passo > 2) { return this.$refs.filial && this.$refs.filial.validate ? this.$refs.filial.validate() : true } return true }],
                etapa3: [() => { if (this.passo > 3) { return this.$refs.desconto && this.$refs.desconto.validate ? this.$refs.desconto.validate() : true } return true }],
                etapa4: [() => { if (this.passo > 4) { return this.$refs.produto && this.$refs.produto.validate ? this.$refs.produto.validate() : true } return true }],
                etapa5: [() => true],
            },
            formTitulo: 'Campanha Circuito',
            resumoKey: 0,
        }
    },
    watch: {
        passo(valor) {
            if (valor == 1) {
                this.botao = 'Avançar';
                this.botaoIco = 'mdi-chevron-right-circle';
            } else if (valor == 5) {
                this.botao = 'Salvar';
                this.botaoIco = 'mdi-check-circle';
            } else {
                this.botao = 'Avançar';
                this.botaoIco = 'mdi-chevron-right-circle';
            }
            this.disabledVoltar = this.passo == 1;

            // Ao entrar na etapa 2, garantir id_espaco único e chamar setAcordo
            if (valor === 2) {
                // Se id_espaco não estiver setado, tenta setar como 'Campanha Circuito'
                if (!this.acordo.id_espaco) {
                    if (this.$refs.cadastro && this.$refs.cadastro.lista && Array.isArray(this.$refs.cadastro.lista.espaco)) {
                        const espacoCircuito = this.$refs.cadastro.lista.espaco.find(e => (e.value || e) === 'Campanha Circuito');
                        if (espacoCircuito) {
                            this.acordo.id_espaco = espacoCircuito.value || espacoCircuito;
                        }
                    }
                }
                if (Array.isArray(this.acordo.id_espaco) && this.acordo.id_espaco.length > 0) {
                    this.acordo.id_espaco = this.acordo.id_espaco[0];
                }
                // Garante que o campo 'organico' existe para evitar erro no componente base
                if (typeof this.acordo.organico === 'undefined') {
                    this.$set(this.acordo, 'organico', null);
                }
                // Chama listaCampos campanha circuito antes de buscar filiais
                if (this.$refs.filial && typeof this.$refs.filial.fetchListaCampos === 'function') {
                    this.$refs.filial.fetchListaCampos().then(() => {
                        if (typeof this.$refs.filial.filtrar === 'function') {
                            this.$refs.filial.filtrar();
                        }
                    });
                } else if (this.$refs.filial && typeof this.$refs.filial.filtrar === 'function') {
                    this.$refs.filial.filtrar();
                }
            }


            // Ao entrar na etapa 3, chama criaDesconto passando os dados necessários igual ao PDV
            if (valor === 3 && this.$refs.desconto && typeof this.$refs.desconto.criaDesconto === 'function') {
                let filiais = this.$refs.filial && this.$refs.filial.filiais ? this.$refs.filial.filiais : [];
                let somaFiliais = this.$refs.filial && this.$refs.filial.somaFiliais ? this.$refs.filial.somaFiliais : [{}, {}];
                let somaFiliaisValor = this.$refs.filial && this.$refs.filial.somaFiliaisValor ? this.$refs.filial.somaFiliaisValor : {};
                let quantidadeFiliais = Array.isArray(filiais) ? filiais.length : 0;
                let errosFiliais = this.$refs.filial && this.$refs.filial.errosFiliais ? this.$refs.filial.errosFiliais : [];
                // Logs para depuração
                if (quantidadeFiliais > 0 && somaFiliais[0] && Object.keys(somaFiliais[0]).length > 0) {
                    this.$refs.desconto.criaDesconto(
                        this.acordo,
                        somaFiliais,
                        somaFiliaisValor,
                        quantidadeFiliais,
                        errosFiliais
                    );
                } else {
                    console.warn('[formulario] Dados insuficientes para chamar desconto');
                }
            }

            // Ao entrar na etapa 4, buscar produtos automaticamente
            if (valor === 4 && this.$refs.produto && this.$refs.produto.buscaProdutos) {
                this.$refs.produto.buscaProdutos();
            }
        },
        dialogForm(valor) {
            // Sempre que abrir o formulário, se id_espaco não estiver setado, tenta setar como 'Campanha Circuito'
            if (valor && !this.acordo.id_espaco) {
                if (this.$refs.cadastro && this.$refs.cadastro.lista && Array.isArray(this.$refs.cadastro.lista.espaco)) {
                    const espacoCircuito = this.$refs.cadastro.lista.espaco.find(e => (e.value || e) === 'Campanha Circuito');
                    if (espacoCircuito) {
                        //this.acordo.id_espaco = espacoCircuito.value || espacoCircuito;
                    }
                }
            }
        }
    },
    methods: {
        async editar(item, leitura = false) {
            // Limpa e reseta todos os campos dos filhos
            try {
                this.$refs.cadastro && this.$refs.cadastro.limpaCadastro && this.$refs.cadastro.limpaCadastro();
                this.$refs.cadastro && this.$refs.cadastro.resetValidation && this.$refs.cadastro.resetValidation();
                this.$refs.filial && this.$refs.filial.limpaSelecionadas && this.$refs.filial.limpaSelecionadas();
                this.$refs.filial && this.$refs.filial.resetValidation && this.$refs.filial.resetValidation();
                this.$refs.produto && this.$refs.produto.limpaProdutos && this.$refs.produto.limpaProdutos();
                this.$refs.produto && this.$refs.produto.resetValidation && this.$refs.produto.resetValidation();
                this.$refs.desconto && this.$refs.desconto.limpaDesconto && this.$refs.desconto.limpaDesconto();
                this.$refs.desconto && this.$refs.desconto.resetValidation && this.$refs.desconto.resetValidation();
            } catch (error) {
                // Ignora erros ao resetar refs
            }

            this.dialogForm = true;
            this.passo = 1;
            this.disabledVoltar = true;
            this.botao = 'Próximo';
            this.botaoIco = 'mdi-chevron-right';
            this.carregando = true;

            try {
                // Busca todos os dados do acordo em um endpoint único, enviando o payload correto
                const response = await this.$http().post('/acordoCampanhaCircuito/acordo', { data: { id_acordo: item.id_acordo } });
                const acordoBackend = response.data.acordo || {};
                // Mapeamento dos campos para o formato esperado pelo formulário
                console.log(acordoBackend);
                this.acordo = {
                    ...acordoBackend,
                    fnEditar: true,
                    fnNovo: false,
                    fnLeitura: leitura,
                    fnReplicar: false,
                    idAcordos: response.data.idAcordos || [],
                    // Datas: converte para YYYY-MM
                    mesInicial: acordoBackend.mes ? acordoBackend.mes.substring(0, 7) : '',
                    mesFinal: acordoBackend.mes ? acordoBackend.mes.substring(0, 7) : '',
                    // Fornecedor: pega nome se vier objeto, senão vazio
                    fornecedor: response.data.fornecedor ? response.data.fornecedor.nome : '',
                    id_fornecedor: acordoBackend.id_fornecedor,
                    // Bandeira: string compatível com v-select
                    bandeira: acordoBackend.bandeira || '',
                    // Produtos e valores: arrays vazios se não vierem (produtos será preenchido abaixo)
                    produtos: [],
                    valores: Array.isArray(acordoBackend.valores) ? acordoBackend.valores : [],
                    // Outros campos que podem ser obrigatórios
                    obs_departamento: acordoBackend.obs_departamento || '',
                    obs_contrato: acordoBackend.obs_contrato || '',
                    comentario: acordoBackend.comentario || '',
                    id_espaco: acordoBackend.id_espaco,
                    categoria_produto: acordoBackend.categoria_produto || '',
                    // Adicione outros campos conforme necessário
                };
                // Busca produtos do acordo e preenche
                try {
                    const data = { id_acordo: item.id_acordo, id_fornecedor: this.acordo.id_fornecedor };
                    console.log(item);
                    const respProdutos = await this.$http().post('/acordoCampanhaCircuito/produtos', { data });
                    this.acordo.produtos = Array.isArray(respProdutos.data.produtos) ? respProdutos.data.produtos : [];
                } catch (e) {
                    this.acordo.produtos = [];
                }
                // Popula os filhos
                await this.$nextTick();
                this.$refs.cadastro && this.$refs.cadastro.setAcordo && this.$refs.cadastro.setAcordo(this.acordo);
                this.$refs.filial && this.$refs.filial.setAcordo && this.$refs.filial.setAcordo(this.acordo);
                this.$refs.produto && this.$refs.produto.setAcordo && this.$refs.produto.setAcordo(this.acordo);
                this.$refs.desconto && this.$refs.desconto.setAcordo && this.$refs.desconto.setAcordo(this.acordo);
            } catch (e) {
                console.error('Erro ao buscar dados completos do acordo', e);
            }
            this.carregando = false;
        },

        async replicarAcordo(item, tipoReplicacao) {
            // Reaproveita o editar para carregar todos os dados do acordo...
            await this.editar(item);
            // ...mas reconfigura como NOVO acordo: ao salvar usa /salvar em vez de /editar
            this.acordo.fnEditar = false;
            this.acordo.fnNovo = true;
            this.acordo.fnReplicar = true;
            this.acordo.tipoReplicacao = tipoReplicacao;
            this.acordo.id_acordo = undefined;
            this.acordo.idAcordos = [];
            this.acordo.id_acordo_title = ' replicado de ' + item.id_acordo;

            // Replicar Bandeira: troca RAIA <-> DROGASIL
            if (tipoReplicacao === 'bandeira') {
                if (this.acordo.bandeira === 'DROGASIL') {
                    this.acordo.bandeira = 'RAIA';
                } else if (this.acordo.bandeira === 'RAIA') {
                    this.acordo.bandeira = 'DROGASIL';
                }
            }

            // Repropaga o acordo (com a nova bandeira) para os componentes filhos
            await this.$nextTick();
            this.$refs.cadastro && this.$refs.cadastro.setAcordo && this.$refs.cadastro.setAcordo(this.acordo);
            this.$refs.filial && this.$refs.filial.setAcordo && this.$refs.filial.setAcordo(this.acordo);
            this.$refs.produto && this.$refs.produto.setAcordo && this.$refs.produto.setAcordo(this.acordo);
            this.$refs.desconto && this.$refs.desconto.setAcordo && this.$refs.desconto.setAcordo(this.acordo);
        },

        async carregarFiliais(item) {
            try {
                const response = await this.$http().post('/acordoCampanhaCircuito/filiais', { id_acordo: item.id_acordo });
                console.log(item);
                this.acordo.filiais = Array.isArray(response.data.filiais) ? response.data.filiais : [];
            } catch (e) {
                console.error('Erro ao carregar filiais', e);
                this.acordo.filiais = [];
            }
        },
        async carregarProdutos(item) {
            try {
                console.log(item);
                const response = await this.$http().post('/acordoCampanhaCircuito/produtos', { id_acordo: item.id_acordo, id_fornecedor: this.acordo.id_fornecedor });
                console.log(item);
                this.acordo.produtos = Array.isArray(response.data.produtos) ? response.data.produtos : [];
            } catch (e) {
                console.error('Erro ao carregar produtos', e);
                this.acordo.produtos = [];
            }
        },
        async carregarDescontos(item) {
            try {
                const payload = {
                    id_acordo: item.id_acordo,
                    mesInicial: item.mesInicial || item.periodoInicial || '',
                    mesFinal: item.mesFinal || item.periodoFinal || ''
                };
                console.log('[formulario] Payload enviado para descontos:', payload);
                const response = await this.$http().post('/acordoCampanhaCircuito/mesDesconto', payload);
                console.log('[formulario] Dados recebidos de descontos:', response.data);
                this.acordo.valores = Array.isArray(response.data.valores) ? response.data.valores : [];
            } catch (e) {
                console.error('Erro ao carregar descontos', e);
                this.acordo.valores = [];
            }
        },
        async carregarCamposExtras(item) {
            try {
                const response = await this.$http().post('/acordoCampanhaCircuito/listaCampos', { id_acordo: item.id_acordo });
                console.log('[formulario] Dados recebidos de campos extras:', response.data);
                // Preencha outros campos extras necessários aqui, se houver
                // Exemplo: this.acordo.marcas = response.data.marcas || [];
            } catch (e) {
                console.error('Erro ao carregar campos extras', e);
            }
        },
        irParaEtapa(novaEtapa) {
            // Valida todas as etapas anteriores
            const refs = ['cadastro', 'filial', 'desconto', 'produto'];
            for (let i = 1; i < novaEtapa; i++) {
                const ref = refs[i - 1];
                if (this.$refs[ref] && this.$refs[ref].validate && !this.$refs[ref].validate()) {
                    this.passo = i;
                    return;
                }
            }
            // Se está saindo da etapa 2 (Filiais), sempre copia as filiais salvas para o acordo
            if (this.passo === 2 && novaEtapa !== 2 && this.$refs.filial) {
                let filiaisSalvas = this.$refs.filial.filiaisSalvas;
                let filiaisSelecionadas = this.$refs.filial.filiais;
                if (Array.isArray(filiaisSalvas) && filiaisSalvas.length > 0) {
                    this.acordo.filiais = [...filiaisSalvas];
                } else if (Array.isArray(filiaisSelecionadas)) {
                    this.acordo.filiais = [...filiaisSelecionadas];
                } else {
                    this.acordo.filiais = [];
                }
            }
            this.passo = novaEtapa;

            // Dispara as ações automáticas das etapas, igual ao watcher de passo
            // Etapa 2: garantir id_espaco único, set organico e fetchListaCampos
            if (novaEtapa === 2) {
                if (!this.acordo.id_espaco) {
                    if (this.$refs.cadastro && this.$refs.cadastro.lista && Array.isArray(this.$refs.cadastro.lista.espaco)) {
                        const espacoCircuito = this.$refs.cadastro.lista.espaco.find(e => (e.value || e) === 'Campanha Circuito');
                        if (espacoCircuito) {
                            this.acordo.id_espaco = espacoCircuito.value || espacoCircuito;
                        }
                    }
                }
                if (Array.isArray(this.acordo.id_espaco) && this.acordo.id_espaco.length > 0) {
                    this.acordo.id_espaco = this.acordo.id_espaco[0];
                }
                if (typeof this.acordo.organico === 'undefined') {
                    this.$set(this.acordo, 'organico', null);
                }
                if (this.$refs.filial && typeof this.$refs.filial.fetchListaCampos === 'function') {
                    this.$refs.filial.fetchListaCampos().then(() => {
                        if (typeof this.$refs.filial.filtrar === 'function') {
                            this.$refs.filial.filtrar();
                        }
                    });
                } else if (this.$refs.filial && typeof this.$refs.filial.filtrar === 'function') {
                    this.$refs.filial.filtrar();
                }
            }
            // Etapa 3: inicializa desconto
            if (novaEtapa === 3 && this.$refs.desconto && typeof this.$refs.desconto.initDesconto === 'function') {
                this.$refs.desconto.initDesconto();
            }
            // Etapa 4: busca produtos
            if (novaEtapa === 4 && this.$refs.produto && this.$refs.produto.buscaProdutos) {
                this.$refs.produto.buscaProdutos();
            }
        },
        async listaCampos() {
            // Chama o endpoint correto do backend para buscar as bandeiras e outros campos
            const response = await this.$http().post('/acordoCampanhaCircuito/listaCampos', {});
            return response.data;
        },
        novo(usuarioTipo) {
            this.acordo = {
                tipo_acordo: 'PDV',
                investimento_total: 0,
                mesInicial: this.$moment().format('YYYY-MM'),
                mesFinal: this.$moment().format('YYYY-MM'),
                id_espaco: 3658,
                id_fornecedor: null,
                fornecedor: null,
                fornecedorDesconto: null,
                bandeira: [],
                obs_departamento: null,
                obs_contrato: null,
                comentario: null,
                fnNovo: true,
                fnEditar: false,
                fnLeitura: false,
                fnReplicar: false,
                id_acordo_title: 0,
                produtos: [],
                valores: [],
            }
            this.usuarioTipo = usuarioTipo || 'rd'
            this.dialogForm = true
            this.passo = 1
            this.disabledVoltar = true
            this.botao = 'Próximo'
            this.botaoIco = 'mdi-chevron-right'
            this.$nextTick(() => {
                try {
                    this.$refs.cadastro && this.$refs.cadastro.limpaCadastro && this.$refs.cadastro.limpaCadastro()
                    this.$refs.produto && this.$refs.produto.limpaProdutos && this.$refs.produto.limpaProdutos()
                    this.$refs.desconto && this.$refs.desconto.limpaDesconto && this.$refs.desconto.limpaDesconto()
                    this.$refs.filial && this.$refs.filial.limpaSelecionadas && this.$refs.filial.limpaSelecionadas()
                    this.$refs.cadastro && this.$refs.cadastro.resetValidation && this.$refs.cadastro.resetValidation()
                    this.$refs.produto && this.$refs.produto.resetValidation && this.$refs.produto.resetValidation()
                    this.$refs.desconto && this.$refs.desconto.resetValidation && this.$refs.desconto.resetValidation()
                    this.$refs.filial && this.$refs.filial.resetValidation && this.$refs.filial.resetValidation()
                } catch (error) {
                    // Ignora erros ao resetar refs
                }
            })
        },
        async proximo() {
            if (this.carregando) return;
            // Antes de avançar para o resumo, garantir que filiais salvas sejam copiadas
            if (this.passo === 4 && this.$refs.filial) {
                // Tenta pegar as filiais salvas (preferencial), senão pega as filiais selecionadas
                let filiaisSalvas = this.$refs.filial.filiaisSalvas;
                let filiaisSelecionadas = this.$refs.filial.filiais;
                if (Array.isArray(filiaisSalvas) && filiaisSalvas.length > 0) {
                    this.acordo.filiais = [...filiaisSalvas];
                } else if (Array.isArray(filiaisSelecionadas)) {
                    this.acordo.filiais = [...filiaisSelecionadas];
                } else {
                    this.acordo.filiais = [];
                }
            }
            if (this.passo === 5) {
                // salvar lógica
                this.carregando = true;
                try {
                    const formData = new FormData();
                    this.acordo.clusters = [
                        ...new Set(this.$refs.filial.filiais.map((e) => e.id_cluster)),
                    ];
                    console.log('[formulario] Acordo a ser salvo:', this.acordo);
                    formData.append("acordo", JSON.stringify(this.acordo));
                    formData.append("desconto", JSON.stringify(this.acordo.valores || []));
                    formData.append("produto", JSON.stringify(this.acordo.produtos || []));
                    // Enviar filiais em blocos de 10, igual ao PDV
                    const filiais = this.acordo.filiais || [];
                    const pages = Math.ceil(filiais.length / 10);
                    for (let i = 0; i < pages; i++) {
                        formData.append(
                            `filiais[${i}]`,
                            JSON.stringify(filiais.slice(i * 10, (i + 1) * 10))
                        );
                    }
                    let rota = this.acordo.fnEditar ? '/acordoCampanhaCircuito/editar' : '/acordoCampanhaCircuito/salvar';
                    await this.$http().post(rota, formData);
                    this.$emit('filtrar')
                } catch (e) {
                    // Pode exibir erro se quiser
                }
                this.carregando = false;
                this.dialogForm = false;
                // Não incrementa passo!
            } else if (this.passo < 5) {
                this.passo++;
            }
        },
        voltar() {
            if (this.carregando) return;
            if (this.passo > 1) this.passo--;
        },
        fecharErros() {
            this.dialogoErro = false;
        },
    },
}
</script>

<style scoped>
</style>
